module.exports = [
	{
		"fund_family_label": "Vanguard",
		"as_of": "202509",
		"fund_id": 194,
		"net_asset_sum": 9981074987767,
		"long_asset_sum": 10166410654304,
		"num_equity_funds": 103,
		"equity_fund_net_assets": 7266785185450,
		"equity_fund_long_assets": 7269708646356,
		"num_e_sri": 6,
		"num_e_usf": 0,
		"sri_long_assets": 42526241116,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 41666137070,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"df_producer_count_sum": 535,
		"df_producer_asset_sum": 23217514926,
		"df_financier_count_sum": 397,
		"df_financier_asset_sum": 193343116898,
		"df_consumer_count_sum": 2034,
		"df_consumer_asset_sum": 634012211494,
		"df_all_count_sum": 2777,
		"df_all_asset_sum": 838728074647,
		"df_all_weight_total": 0.11537299711005876,
		"climate_asset_sum": 608014859814,
		"ff_all_asset_sum": 593090465299,
		"sri_climate_asset_sum": 327413373,
		"sri_with_most_climate_asset": 153799917,
		"name": "Vanguard",
		"fund_family_name": "Vanguard",
		"label": "Vanguard"
	},
	{
		"fund_family_label": "BlackRock/iShares",
		"as_of": "202509",
		"fund_id": 594,
		"net_asset_sum": 4143704566442,
		"long_asset_sum": 4352084896422,
		"num_equity_funds": 313,
		"equity_fund_net_assets": 2841215121058,
		"equity_fund_long_assets": 2854609581161,
		"num_e_sri": 34,
		"num_e_usf": 0,
		"sri_long_assets": 62998230438,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 54389705060,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"df_producer_count_sum": 911,
		"df_producer_asset_sum": 12687764555,
		"df_financier_count_sum": 934,
		"df_financier_asset_sum": 83989807980,
		"df_consumer_count_sum": 3781,
		"df_consumer_asset_sum": 225214908342,
		"df_all_count_sum": 5292,
		"df_all_asset_sum": 316019838546,
		"df_all_weight_total": 0.11070509979072914,
		"climate_asset_sum": 248388289244,
		"ff_all_asset_sum": 241436941458,
		"sri_climate_asset_sum": 3591290125,
		"sri_with_most_climate_asset": 1106671656,
		"name": "BlackRock/iShares",
		"fund_family_name": "BlackRock/iShares",
		"label": "BlackRock/iShares"
	},
	{
		"fund_family_label": "American Funds/Capital Group",
		"as_of": "202509",
		"fund_id": 98,
		"net_asset_sum": 3051295653071,
		"long_asset_sum": 3068224597598,
		"num_equity_funds": 37,
		"equity_fund_net_assets": 2281775806723,
		"equity_fund_long_assets": 2286136624059,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"df_producer_count_sum": 68,
		"df_producer_asset_sum": 9901433968,
		"df_financier_count_sum": 152,
		"df_financier_asset_sum": 56023206644,
		"df_consumer_count_sum": 404,
		"df_consumer_asset_sum": 139091527304,
		"df_all_count_sum": 603,
		"df_all_asset_sum": 202599564540,
		"df_all_weight_total": 0.08862093472798997,
		"climate_asset_sum": 158258500328,
		"ff_all_asset_sum": 152535679174,
		"sri_climate_asset_sum": 0,
		"sri_with_most_climate_asset": 0,
		"name": "American Funds/Capital Group",
		"fund_family_name": "American Funds/Capital Group",
		"label": "American Funds/Capital Group"
	},
	{
		"fund_family_label": "Fidelity Investments",
		"as_of": "202509",
		"fund_id": 544,
		"net_asset_sum": 4312233882546,
		"long_asset_sum": 4395422016205,
		"num_equity_funds": 300,
		"equity_fund_net_assets": 3107819861620,
		"equity_fund_long_assets": 3127226127376,
		"num_e_sri": 21,
		"num_e_usf": 0,
		"sri_long_assets": 8678748078,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 7444825631,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"df_producer_count_sum": 661,
		"df_producer_asset_sum": 7575021830,
		"df_financier_count_sum": 783,
		"df_financier_asset_sum": 66196801507,
		"df_consumer_count_sum": 3356,
		"df_consumer_asset_sum": 246179031654,
		"df_all_count_sum": 4565,
		"df_all_asset_sum": 316842533023,
		"df_all_weight_total": 0.10131743600161622,
		"climate_asset_sum": 230014726520,
		"ff_all_asset_sum": 225717531808,
		"sri_climate_asset_sum": 280431917,
		"sri_with_most_climate_asset": 117586952,
		"name": "Fidelity Investments",
		"fund_family_name": "Fidelity Investments",
		"label": "Fidelity Investments"
	},
	{
		"fund_family_label": "State Street",
		"as_of": "202509",
		"fund_id": 156,
		"net_asset_sum": 1581297579424,
		"long_asset_sum": 1581348698711,
		"num_equity_funds": 94,
		"equity_fund_net_assets": 1372503311307,
		"equity_fund_long_assets": 1372508400418,
		"num_e_sri": 6,
		"num_e_usf": 0,
		"sri_long_assets": 1771948831,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 1759133198,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"df_producer_count_sum": 361,
		"df_producer_asset_sum": 4010769474,
		"df_financier_count_sum": 298,
		"df_financier_asset_sum": 38411069826,
		"df_consumer_count_sum": 1354,
		"df_consumer_asset_sum": 137255474270,
		"df_all_count_sum": 1873,
		"df_all_asset_sum": 177027214139,
		"df_all_weight_total": 0.12898078735626392,
		"climate_asset_sum": 146342130185,
		"ff_all_asset_sum": 142855952085,
		"sri_climate_asset_sum": 100085090,
		"sri_with_most_climate_asset": 51662447,
		"name": "State Street",
		"fund_family_name": "State Street",
		"label": "State Street"
	},
	{
		"fund_family_label": "Schwab Funds",
		"as_of": "202509",
		"fund_id": 95,
		"net_asset_sum": 710597601823,
		"long_asset_sum": 710649798171,
		"num_equity_funds": 43,
		"equity_fund_net_assets": 616378061753,
		"equity_fund_long_assets": 616384413539,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"df_producer_count_sum": 219,
		"df_producer_asset_sum": 3590416305,
		"df_financier_count_sum": 177,
		"df_financier_asset_sum": 15645516581,
		"df_consumer_count_sum": 1064,
		"df_consumer_asset_sum": 58547780580,
		"df_all_count_sum": 1366,
		"df_all_asset_sum": 75713125297,
		"df_all_weight_total": 0.1228342632194243,
		"climate_asset_sum": 63705867738,
		"ff_all_asset_sum": 61478025805,
		"sri_climate_asset_sum": 0,
		"sri_with_most_climate_asset": 0,
		"name": "Schwab Funds",
		"fund_family_name": "Schwab Funds",
		"label": "Schwab Funds"
	},
	{
		"fund_family_label": "Dimensional Fund Advisors",
		"as_of": "202509",
		"fund_id": 144,
		"net_asset_sum": 680815636660,
		"long_asset_sum": 694360586418,
		"num_equity_funds": 78,
		"equity_fund_net_assets": 560771340727,
		"equity_fund_long_assets": 560870721611,
		"num_e_sri": 7,
		"num_e_usf": 0,
		"sri_long_assets": 18054891524,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 16474352065,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"df_producer_count_sum": 1315,
		"df_producer_asset_sum": 3123849187,
		"df_financier_count_sum": 624,
		"df_financier_asset_sum": 15083060388,
		"df_consumer_count_sum": 2356,
		"df_consumer_asset_sum": 32428889007,
		"df_all_count_sum": 4003,
		"df_all_asset_sum": 49287571021,
		"df_all_weight_total": 0.08787688342766466,
		"climate_asset_sum": 55050309535,
		"ff_all_asset_sum": 52795069791,
		"sri_climate_asset_sum": 602731758,
		"sri_with_most_climate_asset": 221784248,
		"name": "Dimensional Fund Advisors",
		"fund_family_name": "Dimensional Fund Advisors",
		"label": "Dimensional Fund Advisors"
	},
	{
		"fund_family_label": "T. Rowe Price",
		"as_of": "202509",
		"fund_id": 184,
		"net_asset_sum": 947068737528,
		"long_asset_sum": 953121278746,
		"num_equity_funds": 81,
		"equity_fund_net_assets": 634261194364,
		"equity_fund_long_assets": 635075020060,
		"num_e_sri": 1,
		"num_e_usf": 0,
		"sri_long_assets": 26174729,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 26174729,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"df_producer_count_sum": 100,
		"df_producer_asset_sum": 2136641891,
		"df_financier_count_sum": 207,
		"df_financier_asset_sum": 11915337764,
		"df_consumer_count_sum": 657,
		"df_consumer_asset_sum": 41479950453,
		"df_all_count_sum": 919,
		"df_all_asset_sum": 54905903150,
		"df_all_weight_total": 0.08645577516938495,
		"climate_asset_sum": 43603354745,
		"ff_all_asset_sum": 41812095764,
		"sri_climate_asset_sum": 849120,
		"sri_with_most_climate_asset": 849120,
		"name": "T. Rowe Price",
		"fund_family_name": "T. Rowe Price",
		"label": "T. Rowe Price"
	},
	{
		"fund_family_label": "Invesco",
		"as_of": "202509",
		"fund_id": 336,
		"net_asset_sum": 1082836492437,
		"long_asset_sum": 1103892055326,
		"num_equity_funds": 202,
		"equity_fund_net_assets": 851089345686,
		"equity_fund_long_assets": 853355550547,
		"num_e_sri": 14,
		"num_e_usf": 0,
		"sri_long_assets": 10579409769,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 8021688837,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"df_producer_count_sum": 204,
		"df_producer_asset_sum": 1666714677,
		"df_financier_count_sum": 280,
		"df_financier_asset_sum": 8920251232,
		"df_consumer_count_sum": 1369,
		"df_consumer_asset_sum": 80316157631,
		"df_all_count_sum": 1748,
		"df_all_asset_sum": 89716841543,
		"df_all_weight_total": 0.10513418643083952,
		"climate_asset_sum": 54830279948,
		"ff_all_asset_sum": 53252211851,
		"sri_climate_asset_sum": 289952889,
		"sri_with_most_climate_asset": 169161562,
		"name": "Invesco",
		"fund_family_name": "Invesco",
		"label": "Invesco"
	},
	{
		"fund_family_label": "TIAA Investments/Nuveen",
		"as_of": "202509",
		"fund_id": 164,
		"net_asset_sum": 694120128398,
		"long_asset_sum": 695499481524,
		"num_equity_funds": 61,
		"equity_fund_net_assets": 454346221294,
		"equity_fund_long_assets": 454373961438,
		"num_e_sri": 15,
		"num_e_usf": 1,
		"sri_long_assets": 44774379120,
		"usf_long_assets": 13332853578,
		"equity_fund_sri_long_assets": 37462148951,
		"equity_fund_usf_long_assets": 6831531662,
		"sustainable_manager": 0,
		"df_producer_count_sum": 198,
		"df_producer_asset_sum": 1642850896,
		"df_financier_count_sum": 181,
		"df_financier_asset_sum": 13070554271,
		"df_consumer_count_sum": 805,
		"df_consumer_asset_sum": 42275525321,
		"df_all_count_sum": 1121,
		"df_all_asset_sum": 56418365571,
		"df_all_weight_total": 0.12416725067705793,
		"climate_asset_sum": 33033515530,
		"ff_all_asset_sum": 32413470395,
		"sri_climate_asset_sum": 1112022910,
		"sri_with_most_climate_asset": 448330050,
		"name": "TIAA Investments/Nuveen",
		"fund_family_name": "TIAA Investments/Nuveen",
		"label": "TIAA Investments/Nuveen"
	}
];


//////////////////
// WEBPACK FOOTER
// ./src/data/FamilyFunds.json
// module id = 960
// module chunks = 0